import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import {
	type ErrorComponentProps,
	useMatch,
	useRouter,
} from '@tanstack/react-router';
import errorImage from '@/assets/global-error.svg?url';
import { Link } from '@/lib/navigation';
import { isForeignEnvironment } from '@/lib/pwa';

export function DefaultCatchBoundary({ reset }: ErrorComponentProps) {
	// TODO: establish an error type to check instance of error to show useful message and error code
	// check is home page
	const isHome = useMatch({
		strict: false,
		select: (state) => state.id === '/',
	});

	const context = useRouter().options.context;
	const isForeign = isForeignEnvironment(context.clientConfig().clientId);

	return (
		<div className="min-h-full flex flex-col">
			<div className="flex flex-col w-full p-15 items-center text-center">
				<img src={errorImage} alt="Error" className="max-w-sm w-full" />
				<Typography variant="h6" as="div" className="mt-20 mb-10">
					Oops! Something went wrong
				</Typography>
				<Typography variant="body-sm">
					Sorry! We cannot process your request at the moment. Please try again
					later.
				</Typography>
				<div className="flex gap-20 mt-20">
					{(!isHome || isForeign) && (
						<Button asChild variant="flat" size="md">
							<Link to="/" back="exit" replace>
								Go Back
							</Link>
						</Button>
					)}
					<Button variant="flat" size="md" onClick={reset}>
						Refresh Page
					</Button>
				</div>
			</div>
		</div>
	);
}
